// import React from "react";

// const AwardsSection = () => {
//   const awards = [
//     {
//       title: "Best Cab Service Award",
//       subtitle: "regional transport",
//       year: "2022",
//       icon: "fa-solid fa-car",
//     },
//     {
//       title: "Punctuality Excellence",
//       subtitle: "on-time service",
//       year: "2023",
//       icon: "fa-regular fa-clock",
//     },
//     {
//       title: "Customer Satisfaction Award",
//       subtitle: "trusted rides",
//       year: "2024",
//       icon: "fa-solid fa-face-smile",
//     },
//   ];

//   return (
//     <div
//       className="awards-style1 space"
//       style={{
//         backgroundImage: "url('/img/awards/awards-style1-bg.png')",
//       }}
//     >
//       <img
//         className="awards-icon-1"
//         src="/img/icons/award-icon-1.png"
//         alt="icon"
//       />
//       <img
//         className="awards-icon-2 move-item"
//         src="/img/icons/award-icon-2.png"
//         alt="icon"
//       />

//       <div className="container">
//         <div className="row justify-content-between align-items-center">
//           <div className="col-md-6 col-lg-6 col-xxl-5">
//             <div className="title-area text-center text-md-start">
//               <span className="sec-subtitle fade-anim" data-direction="bottom">
//                 Recognized for Excellence
//               </span>
//               <h2 className="sec-title fade-anim" data-direction="top">
//                 Awards & Achievements – Mauli Cabs
//               </h2>
//             </div>
//           </div>

//           <div className="col-md-6 col-lg-5 col-xxl-5">
//             <div className="google-reviewed mx-auto overflow-hidden">
//               <div className="left bg-white-color d-flex align-items-center gap-2">
//                 <img src="/img/icons/awards-google.png" alt="google" />
//                 <div className="info">
//                   <strong className="d-block">Google</strong>
//                   <span className="d-block fs-xxs text-uppercase">Reviewed by</span>
//                 </div>
//               </div>
//               <div className="right bg-second-theme-color">
//                 <div className="rating d-flex align-items-baseline gap-2">
//                   <h4 className="fs-32 fw-semibold ff-rubik text-white-color">4.8</h4>
//                   <div className="stars">
//                     <ul className="custom-ul d-flex align-items-center text-theme-color fs-xxs">
//                       {[...Array(5)].map((_, index) => (
//                         <li key={index}><i className="fa-solid fa-star"></i></li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//                 <span className="review fs-xxs d-block">10k+ reviews</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Award Boxes */}
//         <div className="row g-2 g-lg-4 award-box-style1__row">
//           <div className="line-Shape"></div>

//           {awards.map((award, i) => (
//             <div
//               key={i}
//               className="col-md-6 col-lg-4 fade-anim"
//               data-delay={`${0.3 + i * 0.15}`}
//               data-direction="top"
//             >
//               <div className="award-box-style1">
//                 <div className="award-box-style1-wrapper">
//                   <figure className="award-box-icon text-center">
//                     <i className={`${award.icon} fs-1 text-theme-color`}></i>
//                   </figure>
//                   <div className="award-box-header d-flex align-items-end justify-content-between gap-xl-4 text-center">
//                     <img
//                       src="/img/awards/award-box-left-wings.png"
//                       alt="award-box-left-wings"
//                     />
//                     <h6 className="text-capitalize ff-rubik fw-semibold">
//                       {award.title}
//                     </h6>
//                     <img
//                       src="/img/awards/award-box-right-wings.png"
//                       alt="award-box-right-wings"
//                     />
//                   </div>
//                   <div className="award-box-body text-center">
//                     <span className="text-third-theme-color bg-white-color">
//                       {award.subtitle}
//                     </span>
//                   </div>
//                   <div className="award-box-footer text-capitalize text-center">
//                     <p className="line1">
//                       received in <strong>{award.year}</strong>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AwardsSection;
import React from "react";

const ServicesSection = () => {
  const services = [
    {
      title: "Airport Pickup & Drop",
      description: "On-time transport to and from the airport.",
      icon: "fa-solid fa-plane-departure",
    },
    {
      title: "Outstation Travel",
      description: "Safe and reliable intercity rides.",
      icon: "fa-solid fa-road",
    },
    {
      title: "Corporate Travel",
      description: "Comfortable travel for your business needs.",
      icon: "fa-solid fa-briefcase",
    },
  ];

  return (
    <div
      className="services-section py-5"
      style={{ backgroundColor: "#fff", position: "relative" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="d-block fw-bold text-uppercase"
            style={{ color: "#F7921F" }}
          >
            What We Provide
          </span>
          <h2 className="fw-bold" style={{ color: "#631D02" }}>
            Mauli Cabs Services
          </h2>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div
                className="text-center p-4 h-100 rounded shadow-sm"
                style={{
                  backgroundColor: "#fdf8f5",
                  borderTop: "5px solid #F7921F",
                }}
              >
                <div className="mb-3">
                  <i
                    className={`${service.icon}`}
                    style={{ fontSize: "40px", color: "#631D02" }}
                  ></i>
                </div>
                <h5 style={{ color: "#631D02" }}>{service.title}</h5>
                <p style={{ color: "#444" }}>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
